import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  text-align: center;
  z-index: 1;
  h2 {
    color: ${props => props.theme.title.primary};
    font-size: 3rem;
    font-family: 'Gilroy-ExtraBold';
    margin-top: 0px;
  }
`

export const MainContainer = styled.div`
  background-color: ${props => props.theme.colors.grey.tone50};
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p,
  h2,
  h3 {
    z-index: 1;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.title.primary};
  font-family: 'Gilroy-ExtraBold';
  font-size: 1rem;
`

export const ReveniLogo = styled.img`
  height: 60px;
`

const BackgroundCircle = styled.div`
  width: 300px;
  height: 300px;
  border: 40px solid ${props => props.theme.colors.green.tone50};
  position: fixed;
  z-index: 0;
  border-radius: 50%;
`

export const BackgroundCircleBottom = styled(BackgroundCircle)`
  bottom: 0;
  left: -200px;
`

export const BackgroundCircleTop = styled(BackgroundCircle)`
  top: 80px;
  right: -200px;
  width: 200px;
  height: 200px;
`
